import type { DataChartStyleProps } from './datachartStyleRegistry'
import { AirQualityChartBase } from './AirQualityChartBase'

export function AirQualityChartStyle01(props: DataChartStyleProps) {
  return <AirQualityChartBase variant="blue" chartType="area" {...props} />
}
